import { useState } from "react";
import Plus from "../../images/faqs/Add_Plus.png";
import Minus from "../../images/minus.png";
import QuestionsBg from "../../images/faqs/questions-bg.png";

function FaqsMain() {
  const [dropdownActive, setDropDownActive] = useState("");

  return (
    <div className="faqs">
      <div className="hero">
        <p>Got any questions? we've got answers</p>
      </div>
      <div className="questions">
        <div className="container">
          <div className="question">
            <h1>Learn more about Brandone?</h1>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown1"
                  ? setDropDownActive("dropdown1")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>What we do at Brandone?</p>
                <h2 className={dropdownActive === "dropdown1" ? "visible" : ""}>
                  BrandOne is an Enterprise Resource Solution/platform company,
                  that helps organizations, business(small and large scale) to
                  automate their process and scale their businesses. Brandone
                  helps them to bring their technological dreams for their
                  companies/business to life. They develop bespoke solutions
                  tailored to company/business needs.
                </h2>
              </div>
              {dropdownActive !== "dropdown1" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown2"
                  ? setDropDownActive("dropdown2")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>Our development framework?</p>
                <h2 className={dropdownActive === "dropdown2" ? "visible" : ""}>
                  We use Agile/scrum to manage our projects, SOLID/DRIVE design
                  principles to guide our development. We use .netcore (latest),
                  Angular js, React js, React Native for development.
                </h2>
              </div>
              {dropdownActive !== "dropdown2" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown3"
                  ? setDropDownActive("dropdown3")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>What is an ERP?</p>
                <h2 className={dropdownActive === "dropdown3" ? "visible" : ""}>
                  Enterprise Resource Platform, its software solution that aids
                  companies/businesses processes in an integrated system. It
                  helps drive efficiency and provide intelligent ways of doing
                  things.
                </h2>
              </div>
              {dropdownActive !== "dropdown3" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown4"
                  ? setDropDownActive("dropdown4")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>How long has Brandone been in existence?</p>
                <h2 className={dropdownActive === "dropdown4" ? "visible" : ""}>
                  BrandOne has been in existence for 10 years now, the company
                  was established in October 20th, 2013.
                </h2>
              </div>
              {dropdownActive !== "dropdown4" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
          </div>
          <div className="question">
            <h1>Get to know how we build?</h1>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown5"
                  ? setDropDownActive("dropdown5")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>What we do at Brandone?</p>
                <h2 className={dropdownActive === "dropdown5" ? "visible" : ""}>
                  BrandOne is an Enterprise Resource Solution/platform company,
                  that helps organizations, business(small and large scale) to
                  automate their process and scale their businesses. Brandone
                  helps them to bring their technological dreams for their
                  companies/business to life. They develop bespoke solutions
                  tailored to company/business needs.
                </h2>
              </div>
              {dropdownActive !== "dropdown5" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown6"
                  ? setDropDownActive("dropdown6")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>Our development framework?</p>
                <h2 className={dropdownActive === "dropdown6" ? "visible" : ""}>
                  We use Agile/scrum to manage our projects, SOLID/DRIVE design
                  principles to guide our development. We use .netcore (latest),
                  Angular js, React js, React Native for development.
                </h2>
              </div>
              {dropdownActive !== "dropdown6" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown7"
                  ? setDropDownActive("dropdown7")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>What is an ERP?</p>
                <h2 className={dropdownActive === "dropdown7" ? "visible" : ""}>
                  Enterprise Resource Platform, its software solution that aids
                  companies/businesses processes in an integrated system. It
                  helps drive efficiency and provide intelligent ways of doing
                  things.
                </h2>
              </div>
              {dropdownActive !== "dropdown7" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown8"
                  ? setDropDownActive("dropdown8")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>How long has Brandone been in existence?</p>
                <h2 className={dropdownActive === "dropdown8" ? "visible" : ""}>
                  BrandOne has been in existence for 10 years now, the company
                  was established in October 20th, 2013.
                </h2>
              </div>
              {dropdownActive !== "dropdown8" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
          </div>
          <div className="question">
            <h1>What have we built?</h1>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown9"
                  ? setDropDownActive("dropdown9")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>What we do at Brandone?</p>
                <h2 className={dropdownActive === "dropdown9" ? "visible" : ""}>
                  BrandOne is an Enterprise Resource Solution/platform company,
                  that helps organizations, business(small and large scale) to
                  automate their process and scale their businesses. Brandone
                  helps them to bring their technological dreams for their
                  companies/business to life. They develop bespoke solutions
                  tailored to company/business needs.
                </h2>
              </div>
              {dropdownActive !== "dropdown9" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown10"
                  ? setDropDownActive("dropdown10")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>Our development framework?</p>
                <h2
                  className={dropdownActive === "dropdown10" ? "visible" : ""}
                >
                  We use Agile/scrum to manage our projects, SOLID/DRIVE design
                  principles to guide our development. We use .netcore (latest),
                  Angular js, React js, React Native for development.
                </h2>
              </div>
              {dropdownActive !== "dropdown10" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown11"
                  ? setDropDownActive("dropdown11")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>What is an ERP?</p>
                <h2
                  className={dropdownActive === "dropdown11" ? "visible" : ""}
                >
                  Enterprise Resource Platform, its software solution that aids
                  companies/businesses processes in an integrated system. It
                  helps drive efficiency and provide intelligent ways of doing
                  things.
                </h2>
              </div>
              {dropdownActive !== "dropdown11" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown12"
                  ? setDropDownActive("dropdown12")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>How long has Brandone been in existence?</p>
                <h2
                  className={dropdownActive === "dropdown12" ? "visible" : ""}
                >
                  BrandOne has been in existence for 10 years now, the company
                  was established in October 20th, 2013.
                </h2>
              </div>
              {dropdownActive !== "dropdown12" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
          </div>
          <div className="question">
            <h1>Everything, in between</h1>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown13"
                  ? setDropDownActive("dropdown13")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>What we do at Brandone?</p>
                <h2
                  className={dropdownActive === "dropdown13" ? "visible" : ""}
                >
                  BrandOne is an Enterprise Resource Solution/platform company,
                  that helps organizations, business(small and large scale) to
                  automate their process and scale their businesses. Brandone
                  helps them to bring their technological dreams for their
                  companies/business to life. They develop bespoke solutions
                  tailored to company/business needs.
                </h2>
              </div>
              {dropdownActive !== "dropdown13" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown14"
                  ? setDropDownActive("dropdown14")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>Our development framework?</p>
                <h2
                  className={dropdownActive === "dropdown14" ? "visible" : ""}
                >
                  We use Agile/scrum to manage our projects, SOLID/DRIVE design
                  principles to guide our development. We use .netcore (latest),
                  Angular js, React js, React Native for development.
                </h2>
              </div>
              {dropdownActive !== "dropdown14" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown15"
                  ? setDropDownActive("dropdown15")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>What is an ERP?</p>
                <h2
                  className={dropdownActive === "dropdown15" ? "visible" : ""}
                >
                  Enterprise Resource Platform, its software solution that aids
                  companies/businesses processes in an integrated system. It
                  helps drive efficiency and provide intelligent ways of doing
                  things.
                </h2>
              </div>
              {dropdownActive !== "dropdown15" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
            <div
              className="each"
              onClick={() => {
                dropdownActive !== "dropdown16"
                  ? setDropDownActive("dropdown16")
                  : setDropDownActive("");
              }}
            >
              <div>
                <p>How long has Brandone been in existence?</p>
                <h2
                  className={dropdownActive === "dropdown16" ? "visible" : ""}
                >
                  BrandOne has been in existence for 10 years now, the company
                  was established in October 20th, 2013.
                </h2>
              </div>
              {dropdownActive !== "dropdown16" ? (
                <img className="plus" src={Plus} alt="plus" />
              ) : (
                <img className="minus" src={Minus} alt="minus" />
              )}
            </div>
          </div>
        </div>
        <img src={QuestionsBg} className="bg-image" alt="bg" />
      </div>
    </div>
  );
}

export default FaqsMain;
